import { Directive, Input } from '@angular/core';
import { PhxStickyColumnInfo } from '../phx-table.types';

/** Applies sticky-column classes and offset to a cell or header. */
@Directive({
  selector: '[phxStickyCol]',
  host: {
    '[class.phx-table-sticky-col]': 'phxStickyCol',
    '[class.phx-table-sticky-col-start]': 'phxStickyCol?.side === "start"',
    '[class.phx-table-sticky-col-end]': 'phxStickyCol?.side === "end"',
    '[class.phx-table-sticky-col-edge]': 'phxStickyCol?.isEdge',
    '[style.left]': 'phxStickyCol?.side === "start" ? phxStickyCol.offset : null',
    '[style.right]': 'phxStickyCol?.side === "end" ? phxStickyCol.offset : null',
  },
})
export class PhxStickyColDirective {
  /** Resolved sticky-column metadata; `undefined` for non-sticky columns. */
  @Input() phxStickyCol: PhxStickyColumnInfo | undefined;
}
